import { useFetchTasksQuery } from '../tasksApi';

export const useTasks = (params = {}, options = {}) => {
  return useFetchTasksQuery(params, {
    ...options,
    selectFromResult: ({ data, isLoading, isFetching, isError, isUninitialized, error, refetch }) => ({
      data: data,
      tasks: data?.tasks || [],
      taskUserCounts: data?.taskUserCounts || [],
      questions: data?.questions || [],
      users: data?.users || [],
      isLoading,
      isFetching,
      isError,
      isUninitialized,
      error,
      refetch,
    }),
  });
};
